import { render, staticRenderFns } from "./BankAccType.vue?vue&type=template&id=1daf5be6&"
import script from "./BankAccType.vue?vue&type=script&lang=js&"
export * from "./BankAccType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports